import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M4 4h16M4 20h16m0-12v-.01M20 12v-.01M20 16v-.01M16 12v-.01M12 8v-.01M12 12v-.01M12 16v-.01M8 12v-.01M4 8v-.01M4 12v-.01M4 16v-.01"
    }, null, -1)
  ]))]))
}
export default { render: render }